var cov_2a4j11hbgx = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/paramUtils.ts",
      hash = "5363e8850005b351c53744ac568786ebb7301ed6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/paramUtils.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 44
        },
        end: {
          line: 4,
          column: 49
        }
      },
      "1": {
        start: {
          line: 15,
          column: 51
        },
        end: {
          line: 21,
          column: 53
        }
      },
      "2": {
        start: {
          line: 15,
          column: 72
        },
        end: {
          line: 21,
          column: 53
        }
      },
      "3": {
        start: {
          line: 21,
          column: 5
        },
        end: {
          line: 21,
          column: 53
        }
      },
      "4": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 23,
          column: 59
        }
      },
      "5": {
        start: {
          line: 24,
          column: 32
        },
        end: {
          line: 24,
          column: 61
        }
      },
      "6": {
        start: {
          line: 25,
          column: 34
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "7": {
        start: {
          line: 26,
          column: 30
        },
        end: {
          line: 26,
          column: 57
        }
      },
      "8": {
        start: {
          line: 27,
          column: 31
        },
        end: {
          line: 27,
          column: 59
        }
      },
      "9": {
        start: {
          line: 28,
          column: 31
        },
        end: {
          line: 28,
          column: 59
        }
      },
      "10": {
        start: {
          line: 29,
          column: 32
        },
        end: {
          line: 29,
          column: 61
        }
      },
      "11": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 98
        }
      },
      "12": {
        start: {
          line: 32,
          column: 40
        },
        end: {
          line: 32,
          column: 98
        }
      },
      "13": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 97
        }
      },
      "14": {
        start: {
          line: 33,
          column: 42
        },
        end: {
          line: 33,
          column: 97
        }
      },
      "15": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 18
        }
      },
      "16": {
        start: {
          line: 48,
          column: 87
        },
        end: {
          line: 48,
          column: 93
        }
      },
      "17": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 50,
          column: 77
        }
      },
      "18": {
        start: {
          line: 50,
          column: 50
        },
        end: {
          line: 50,
          column: 77
        }
      },
      "19": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 85
        }
      },
      "20": {
        start: {
          line: 51,
          column: 20
        },
        end: {
          line: 51,
          column: 85
        }
      },
      "21": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 29
        }
      },
      "22": {
        start: {
          line: 52,
          column: 18
        },
        end: {
          line: 52,
          column: 29
        }
      },
      "23": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "24": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 46
        }
      },
      "25": {
        start: {
          line: 54,
          column: 35
        },
        end: {
          line: 54,
          column: 46
        }
      },
      "26": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "27": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 46
        }
      },
      "28": {
        start: {
          line: 57,
          column: 35
        },
        end: {
          line: 57,
          column: 46
        }
      },
      "29": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "30": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "31": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 17
        }
      },
      "32": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 14
        }
      },
      "33": {
        start: {
          line: 80,
          column: 102
        },
        end: {
          line: 80,
          column: 108
        }
      },
      "34": {
        start: {
          line: 81,
          column: 13
        },
        end: {
          line: 81,
          column: 38
        }
      },
      "35": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 113,
          column: 3
        }
      },
      "36": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 60
        }
      },
      "37": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 11
        }
      },
      "38": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 90,
          column: 7
        }
      },
      "39": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 67
        }
      },
      "40": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 13
        }
      },
      "41": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 60
        }
      },
      "42": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 11
        }
      },
      "43": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 62
        }
      },
      "44": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 11
        }
      },
      "45": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 62
        }
      },
      "46": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 11
        }
      },
      "47": {
        start: {
          line: 103,
          column: 22
        },
        end: {
          line: 103,
          column: 62
        }
      },
      "48": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 108,
          column: 9
        }
      },
      "49": {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 105,
          column: 68
        }
      },
      "50": {
        start: {
          line: 106,
          column: 15
        },
        end: {
          line: 108,
          column: 9
        }
      },
      "51": {
        start: {
          line: 107,
          column: 10
        },
        end: {
          line: 107,
          column: 68
        }
      },
      "52": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 11
        }
      },
      "53": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 11
        }
      },
      "54": {
        start: {
          line: 115,
          column: 21
        },
        end: {
          line: 125,
          column: 4
        }
      },
      "55": {
        start: {
          line: 126,
          column: 2
        },
        end: {
          line: 126,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 15,
            column: 52
          }
        },
        loc: {
          start: {
            line: 15,
            column: 72
          },
          end: {
            line: 21,
            column: 53
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 72
          },
          end: {
            line: 15,
            column: 73
          }
        },
        loc: {
          start: {
            line: 21,
            column: 5
          },
          end: {
            line: 21,
            column: 53
          }
        },
        line: 21
      },
      "2": {
        name: "handleTimeDisabled",
        decl: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 27
          }
        },
        loc: {
          start: {
            line: 31,
            column: 96
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 31
      },
      "3": {
        name: "handleDisabled",
        decl: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 23
          }
        },
        loc: {
          start: {
            line: 47,
            column: 3
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 47
      },
      "4": {
        name: "judgeTimeByRange",
        decl: {
          start: {
            line: 67,
            column: 9
          },
          end: {
            line: 67,
            column: 25
          }
        },
        loc: {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 127,
            column: 1
          }
        },
        line: 79
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 98
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 98
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 98
          }
        }],
        line: 32
      },
      "1": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 97
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 97
          }
        }, {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 97
          }
        }],
        line: 33
      },
      "2": {
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 77
          }
        }, {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 77
          }
        }],
        line: 50
      },
      "3": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 14
          }
        }, {
          start: {
            line: 50,
            column: 18
          },
          end: {
            line: 50,
            column: 48
          }
        }],
        line: 50
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 85
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 85
          }
        }, {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 85
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 51,
            column: 33
          },
          end: {
            line: 51,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 33
          },
          end: {
            line: 51,
            column: 43
          }
        }, {
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 85
          }
        }],
        line: 51
      },
      "6": {
        loc: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 29
          }
        }, {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 29
          }
        }],
        line: 52
      },
      "7": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        }, {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        }],
        line: 53
      },
      "8": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 17
          }
        }, {
          start: {
            line: 53,
            column: 21
          },
          end: {
            line: 53,
            column: 24
          }
        }],
        line: 53
      },
      "9": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 46
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 46
          }
        }],
        line: 54
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }],
        line: 56
      },
      "11": {
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 56,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 56,
            column: 17
          }
        }, {
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 24
          }
        }],
        line: 56
      },
      "12": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 46
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 46
          }
        }],
        line: 57
      },
      "13": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }, {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }],
        line: 59
      },
      "14": {
        loc: {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 59,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 59,
            column: 17
          }
        }, {
          start: {
            line: 59,
            column: 21
          },
          end: {
            line: 59,
            column: 32
          }
        }, {
          start: {
            line: 59,
            column: 36
          },
          end: {
            line: 59,
            column: 45
          }
        }, {
          start: {
            line: 59,
            column: 49
          },
          end: {
            line: 59,
            column: 61
          }
        }],
        line: 59
      },
      "15": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 60
      },
      "16": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 111
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 33
          }
        }, {
          start: {
            line: 60,
            column: 37
          },
          end: {
            line: 60,
            column: 111
          }
        }],
        line: 60
      },
      "17": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 11
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 92,
            column: 11
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 13
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 11
          }
        }, {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 13
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 100,
            column: 11
          }
        }, {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 110,
            column: 11
          }
        }, {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 112,
            column: 11
          }
        }],
        line: 82
      },
      "18": {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        }],
        line: 87
      },
      "19": {
        loc: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        }, {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        }],
        line: 104
      },
      "20": {
        loc: {
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 104,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 104,
            column: 24
          }
        }, {
          start: {
            line: 104,
            column: 28
          },
          end: {
            line: 104,
            column: 38
          }
        }],
        line: 104
      },
      "21": {
        loc: {
          start: {
            line: 106,
            column: 15
          },
          end: {
            line: 108,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 15
          },
          end: {
            line: 108,
            column: 9
          }
        }, {
          start: {
            line: 106,
            column: 15
          },
          end: {
            line: 108,
            column: 9
          }
        }],
        line: 106
      },
      "22": {
        loc: {
          start: {
            line: 106,
            column: 19
          },
          end: {
            line: 106,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 19
          },
          end: {
            line: 106,
            column: 31
          }
        }, {
          start: {
            line: 106,
            column: 35
          },
          end: {
            line: 106,
            column: 46
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0, 0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import utils from './utils';

var _ref = (cov_2a4j11hbgx.s[0]++, utils),
    TIME_FORMAT = _ref.TIME_FORMAT,
    compareAsc = _ref.compareAsc,
    format = _ref.format;

cov_2a4j11hbgx.s[1]++;

var handleOnChangeParams = function handleOnChangeParams(type) {
  cov_2a4j11hbgx.f[0]++;
  cov_2a4j11hbgx.s[2]++;
  return function (date, change, blur, isEnd, isQuickSelect) {
    cov_2a4j11hbgx.f[1]++;
    cov_2a4j11hbgx.s[3]++;
    return [date, change, blur, isEnd, isQuickSelect, type];
  };
};

var yearHandleChangeParams = (cov_2a4j11hbgx.s[4]++, handleOnChangeParams('year'));
var monthHandleChangeParams = (cov_2a4j11hbgx.s[5]++, handleOnChangeParams('month'));
var quarterHandleChangeParams = (cov_2a4j11hbgx.s[6]++, handleOnChangeParams('quarter'));
var dayHandleChangeParams = (cov_2a4j11hbgx.s[7]++, handleOnChangeParams('day'));
var weekHandleChangeParams = (cov_2a4j11hbgx.s[8]++, handleOnChangeParams('week'));
var timeHandleChangeParams = (cov_2a4j11hbgx.s[9]++, handleOnChangeParams('time'));
var quickHandleChangeParams = (cov_2a4j11hbgx.s[10]++, handleOnChangeParams('quick'));

function handleTimeDisabled(date, disabledTime, options) {
  cov_2a4j11hbgx.f[2]++;
  cov_2a4j11hbgx.s[11]++;

  if (typeof disabledTime === 'string') {
    cov_2a4j11hbgx.b[0][0]++;
    cov_2a4j11hbgx.s[12]++;
    return format(date, TIME_FORMAT, options) === disabledTime;
  } else {
    cov_2a4j11hbgx.b[0][1]++;
  }

  cov_2a4j11hbgx.s[13]++;

  if (typeof disabledTime === 'function') {
    cov_2a4j11hbgx.b[1][0]++;
    cov_2a4j11hbgx.s[14]++;
    return disabledTime(format(date, TIME_FORMAT, options));
  } else {
    cov_2a4j11hbgx.b[1][1]++;
  }

  cov_2a4j11hbgx.s[15]++;
  return undefined;
}

function handleDisabled(params) {
  cov_2a4j11hbgx.f[3]++;

  var _ref2 = (cov_2a4j11hbgx.s[16]++, params),
      date = _ref2.date,
      min = _ref2.min,
      max = _ref2.max,
      range = _ref2.range,
      disabled = _ref2.disabled,
      disabledTime = _ref2.disabledTime,
      options = _ref2.options,
      index = _ref2.index,
      rangeDate = _ref2.rangeDate;

  var isDisabled;
  cov_2a4j11hbgx.s[17]++;

  if ((cov_2a4j11hbgx.b[3][0]++, disabled) && (cov_2a4j11hbgx.b[3][1]++, typeof disabled === 'function')) {
    cov_2a4j11hbgx.b[2][0]++;
    cov_2a4j11hbgx.s[18]++;
    isDisabled = disabled(date);
  } else {
    cov_2a4j11hbgx.b[2][1]++;
  }

  cov_2a4j11hbgx.s[19]++;

  if (disabledTime) {
    cov_2a4j11hbgx.b[4][0]++;
    cov_2a4j11hbgx.s[20]++;
    isDisabled = (cov_2a4j11hbgx.b[5][0]++, isDisabled) || (cov_2a4j11hbgx.b[5][1]++, handleTimeDisabled(date, disabledTime));
  } else {
    cov_2a4j11hbgx.b[4][1]++;
  }

  cov_2a4j11hbgx.s[21]++;

  if (isDisabled) {
    cov_2a4j11hbgx.b[6][0]++;
    cov_2a4j11hbgx.s[22]++;
    return true;
  } else {
    cov_2a4j11hbgx.b[6][1]++;
  }

  cov_2a4j11hbgx.s[23]++;

  if ((cov_2a4j11hbgx.b[8][0]++, !isDisabled) && (cov_2a4j11hbgx.b[8][1]++, min)) {
    cov_2a4j11hbgx.b[7][0]++;
    cov_2a4j11hbgx.s[24]++;

    if (compareAsc(date, min) < 0) {
      cov_2a4j11hbgx.b[9][0]++;
      cov_2a4j11hbgx.s[25]++;
      return true;
    } else {
      cov_2a4j11hbgx.b[9][1]++;
    }
  } else {
    cov_2a4j11hbgx.b[7][1]++;
  }

  cov_2a4j11hbgx.s[26]++;

  if ((cov_2a4j11hbgx.b[11][0]++, !isDisabled) && (cov_2a4j11hbgx.b[11][1]++, max)) {
    cov_2a4j11hbgx.b[10][0]++;
    cov_2a4j11hbgx.s[27]++;

    if (compareAsc(date, max) > 0) {
      cov_2a4j11hbgx.b[12][0]++;
      cov_2a4j11hbgx.s[28]++;
      return true;
    } else {
      cov_2a4j11hbgx.b[12][1]++;
    }
  } else {
    cov_2a4j11hbgx.b[10][1]++;
  }

  cov_2a4j11hbgx.s[29]++;

  if ((cov_2a4j11hbgx.b[14][0]++, !isDisabled) && (cov_2a4j11hbgx.b[14][1]++, index === 1) && (cov_2a4j11hbgx.b[14][2]++, rangeDate) && (cov_2a4j11hbgx.b[14][3]++, rangeDate[0])) {
    cov_2a4j11hbgx.b[13][0]++;
    cov_2a4j11hbgx.s[30]++;

    if ((cov_2a4j11hbgx.b[16][0]++, typeof range === 'number') && (cov_2a4j11hbgx.b[16][1]++, utils.compareAsc(date, utils.addSeconds(rangeDate[0], range, options)) > 0)) {
      cov_2a4j11hbgx.b[15][0]++;
      cov_2a4j11hbgx.s[31]++;
      return true;
    } else {
      cov_2a4j11hbgx.b[15][1]++;
    }
  } else {
    cov_2a4j11hbgx.b[13][1]++;
  }

  cov_2a4j11hbgx.s[32]++;
  return false;
}

function judgeTimeByRange(params) {
  cov_2a4j11hbgx.f[4]++;

  var _ref3 = (cov_2a4j11hbgx.s[33]++, params),
      target = _ref3.target,
      value = _ref3.value,
      mode = _ref3.mode,
      min = _ref3.min,
      max = _ref3.max,
      range = _ref3.range,
      disabled = _ref3.disabled,
      disabledTime = _ref3.disabledTime,
      index = _ref3.index,
      rangeDate = _ref3.rangeDate,
      options = _ref3.options;

  var date = (cov_2a4j11hbgx.s[34]++, new Date(value.getTime()));
  cov_2a4j11hbgx.s[35]++;

  switch (mode) {
    case 'H':
      cov_2a4j11hbgx.b[17][0]++;
      cov_2a4j11hbgx.s[36]++;
      date = utils.changeDate(date, 'hour', target, options);
      cov_2a4j11hbgx.s[37]++;
      break;

    case 'h':
      cov_2a4j11hbgx.b[17][1]++;
      cov_2a4j11hbgx.s[38]++;

      if (utils.getDateInfo(date, 'hour', options) >= 12) {
        cov_2a4j11hbgx.b[18][0]++;
        cov_2a4j11hbgx.s[39]++;
        date = utils.changeDate(date, 'hour', target + 12, options);
        cov_2a4j11hbgx.s[40]++;
        break;
      } else {
        cov_2a4j11hbgx.b[18][1]++;
      }

      cov_2a4j11hbgx.s[41]++;
      date = utils.changeDate(date, 'hour', target, options);
      cov_2a4j11hbgx.s[42]++;
      break;

    case 'm':
      cov_2a4j11hbgx.b[17][2]++;

    case 'minute':
      cov_2a4j11hbgx.b[17][3]++;
      cov_2a4j11hbgx.s[43]++;
      date = utils.changeDate(date, 'minute', target, options);
      cov_2a4j11hbgx.s[44]++;
      break;

    case 's':
      cov_2a4j11hbgx.b[17][4]++;

    case 'second':
      cov_2a4j11hbgx.b[17][5]++;
      cov_2a4j11hbgx.s[45]++;
      date = utils.changeDate(date, 'second', target, options);
      cov_2a4j11hbgx.s[46]++;
      break;

    case 'ampm':
      cov_2a4j11hbgx.b[17][6]++;
      {
        var hours = (cov_2a4j11hbgx.s[47]++, utils.getDateInfo(date, 'hour', options));
        cov_2a4j11hbgx.s[48]++;

        if ((cov_2a4j11hbgx.b[20][0]++, target === 1) && (cov_2a4j11hbgx.b[20][1]++, hours < 12)) {
          cov_2a4j11hbgx.b[19][0]++;
          cov_2a4j11hbgx.s[49]++;
          date = utils.changeDate(date, 'hour', hours + 12, options);
        } else {
          cov_2a4j11hbgx.b[19][1]++;
          cov_2a4j11hbgx.s[50]++;

          if ((cov_2a4j11hbgx.b[22][0]++, target === 0) && (cov_2a4j11hbgx.b[22][1]++, hours >= 12)) {
            cov_2a4j11hbgx.b[21][0]++;
            cov_2a4j11hbgx.s[51]++;
            date = utils.changeDate(date, 'hour', hours - 12, options);
          } else {
            cov_2a4j11hbgx.b[21][1]++;
          }
        }
      }
      cov_2a4j11hbgx.s[52]++;
      break;

    default:
      cov_2a4j11hbgx.b[17][7]++;
      cov_2a4j11hbgx.s[53]++;
      break;
  }

  var isDisabled = (cov_2a4j11hbgx.s[54]++, handleDisabled({
    date: date,
    min: min,
    max: max,
    range: range,
    disabled: disabled,
    disabledTime: disabledTime,
    options: options,
    index: index,
    rangeDate: rangeDate
  }));
  cov_2a4j11hbgx.s[55]++;
  return [isDisabled, date];
}

export default {
  handleOnChangeParams: handleOnChangeParams,
  yearHandleChangeParams: yearHandleChangeParams,
  monthHandleChangeParams: monthHandleChangeParams,
  dayHandleChangeParams: dayHandleChangeParams,
  timeHandleChangeParams: timeHandleChangeParams,
  quickHandleChangeParams: quickHandleChangeParams,
  weekHandleChangeParams: weekHandleChangeParams,
  quarterHandleChangeParams: quarterHandleChangeParams,
  judgeTimeByRange: judgeTimeByRange,
  handleTimeDisabled: handleTimeDisabled,
  handleDisabled: handleDisabled
};